/**
 * Width of the panel docked beside the page (alerts, notifications, release
 * notes, help). The value lives in `--side-panel-width` (src/index.css) so
 * CSS can offset anything that must clear the panel by it.
 */
export const SIDE_PANEL_WIDTH = 'var(--side-panel-width)'
